module.exports = __webpack_public_path__ + "img/dogecoin.5753d537.png";